import { CartLinesUpdateEvent } from '@shopify/events';

/* Pairs with / Buy it with / Complete the look: open-close the panel and add items to the bag.
   Uses document-level delegation so it keeps working when the cart drawer re-renders. */
if (!window.__amariPairsWith) {
  window.__amariPairsWith = true;

  const addItem = async (btn) => {
    const id = btn.dataset.variantId;
    if (!id || btn.disabled) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: id, quantity: 1 }],
        promise: deferred.promise,
      })
    );
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1, sections: sectionIds.join(',') }),
      });
      const data = await res.json();
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      if (data.status) {
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { didError: true, items: cart.items, source: 'pairs-with', sourceId: id, itemCount: 1, productId: btn.dataset.productId },
        });
        btn.textContent = 'Sold out';
        return;
      }
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { didError: false, items: cart.items, source: 'pairs-with', sourceId: id, itemCount: 1, productId: btn.dataset.productId, sections: data.sections },
      });
      btn.textContent = 'Added';
      btn.closest('dialog')?.close();
      setTimeout(() => {
        btn.textContent = label;
        btn.disabled = false;
      }, 1800);
    } catch (e) {
      deferred.reject(e);
      btn.textContent = label;
      btn.disabled = false;
    }
  };

  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    const open = t.closest('[data-pw-open]');
    if (open) {
      document.getElementById(open.getAttribute('data-pw-open'))?.showModal();
      return;
    }
    if (t.closest('[data-pw-close]')) {
      t.closest('dialog')?.close();
      return;
    }
    if (t.matches('dialog.pairs-with__dialog')) {
      t.close();
      return;
    }
    const add = t.closest('[data-pw-add]');
    if (add) addItem(add);
  });
}
